import { Button, Divider, NewTableAdv } from "../../../components";
import { mapTableRows } from "../../../utils";

const Onboarding = () => {

  const colDetails = [
    {
      key: "invoiceNumber",
      label: "Invoice Number",
    },
    {
      key: "employeeName",
      label: "Employee Name",
    },
    {
      key: "employeeId",
      label: "Employee ID",
    },
    {
      key: "vendor",
      label: "Vendor",
    },
    {
      key: "vendorCode",
      label: "Vendor Code",
    },
    {
      key: "businessUnit",
      label: "Business Unit",
    },
    {
      key: "invoiceDate",
      label: "Invoice Date",
    },
    {
      key: "invoiceDueDate",
      label: "Invoice Due Date",
    },
    {
      key: "invoiceAmount",
      label: "Invoice Amount",
    },
  ];

 const rows = Array.from({ length: 10 }, (_, i) => ({
    invoiceNumber: `INV-100${i + 1}`,
    employeeName: "Ershad",
    employeeId: `EMP001${i + 1}`,
    vendor: "Tech Solutions Ltd",
    vendorCode: `VEND00${i + 1}`,
    businessUnit: "IT Services",
    invoiceDate: `2025-01-${15 + i}`,
    invoiceDueDate: `2025-02-${15 + i}`,
    invoiceAmount: "₹120,000",
  }));
 

  const mappedrows = mapTableRows(rows, colDetails);

  return (
    <div className="px-3">
      <NewTableAdv
        showCheckbox
        columns={colDetails}
        rows={mappedrows}
        tdClassName="!py-4"
        toolbarRight={{
          search: true,
          add: [
            {
              component: (
                <div className="flex items-center px-2">
                  <Divider orientation="vertical" />
                  <Button
                    type="icon"
                    icon={"refresh"}
                    color="black"
                    variant="text"
                  />
                </div>
              ),
            },
          ],
        }}
      />
    </div>
  );
};

export default Onboarding;